import { render, staticRenderFns } from "./stickerManager.vue?vue&type=template&id=268c6178"
import script from "./stickerManager.vue?vue&type=script&lang=js"
export * from "./stickerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports